// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import Buefy from 'buefy';
import VeeValidate from 'vee-validate';
import App from './App';
import ContactForm from './components/ContactUsForm';
import router from './router';
import store from './store';
import VueFroala from 'vue-froala-wysiwyg';
import { HTTP } from './http';
import { Validator } from 'vee-validate';
import 'buefy/dist/buefy.min.css';
import '../style.css';
import { parse } from 'libphonenumber-js';
import { card, cvc, expiration } from 'creditcards';

import 'froala-editor/css/froala_style.min.css';
require('froala-editor/js/froala_editor.pkgd.min');

Vue.config.productionTip = false;

Vue.use(VeeValidate);
Vue.use(VueFroala);
//Imported to parse the time
Vue.use(require('vue-moment'));

Vue.use(Buefy, {
  defaultIconPack: 'fa',
});

Validator.extend('emailAvailable', {
  getMessage: (field) => 'This email is already registered',
  validate: (value) =>
    HTTP.get('/auth/email_availability?email=' + encodeURIComponent(value)).then((resp) => resp.data.available),
});

Validator.extend('pageNameAvailable', {
  getMessage: (field) => 'There is already a page with this name',
  validate: (value) =>
    HTTP.get('/pages/pagename_availability?pagename=' + encodeURIComponent(value)).then((resp) => resp.data.available),
});

Validator.extend('phone', {
  getMessage: (field) => 'This phone number is not valid',
  validate: (value) => {
    return Object.keys(parse(value, { country: { default: 'CA' } })).length !== 0;
  },
});

Validator.extend('postalCode', {
  validate: (value) => {
    let pCode = new RegExp(/^[ABCEGHJ-NPRSTVXY]\d[ABCEGHJ-NPRSTV-Z][ -]?\d[ABCEGHJ-NPRSTV-Z]\d$/i);

    return pCode.test(value);
  },
  getMessage: (field) => 'This postal code is not valid',
});

Validator.extend('creditCard', {
  validate: (value) => {
    let num = card.parse(value);
    return card.isValid(num);
  },

  getMessage: (field) => 'Please enter a valid credit card number',
});

Validator.extend('cvc', {
  validate: (value) => {
    return cvc.isValid(value);
  },
  getMessage: (field) => 'Please enter a valid cvc number',
});

Validator.extend('expMonth', {
  validate: (value) => {
    return expiration.month.isValid(expiration.month.parse(value));
  },
  getMessage: (field) => 'Please enter a valid expiration month',
});

Validator.extend('expYear', {
  validate: (value) => {
    return expiration.year.isValid(expiration.year.parse(value));
  },
  getMessage: (field) => 'Please enter a valid expiration year',
});

Vue.component('contact-us-form', ContactForm);

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  template: '<App/>',
  components: { App },
});



// WEBPACK FOOTER //
// ./src/main.js